import type React from "react";
import "./LowerPart.scss";
import { format } from "date-fns";
import { GiLevelEndFlag } from "react-icons/gi";
import { LiaLanguageSolid } from "react-icons/lia";
import { MdOutlineSecurityUpdateGood } from "react-icons/md";
import {
	PiCertificateBold,
	PiInfinityLight,
	PiStudentDuotone,
} from "react-icons/pi";
import type { LessonType } from "../../../entities/Lesson/types/LessonType";
import ActivityCard from "./ActivityCard";

type Props = {
	data: LessonType;
};

const LowerPart: React.FC<Props> = ({ data }) => {
	const couseDetailsList = [
		{
			title: "17k learners",
			icon: <PiStudentDuotone />,
		},
		{
			title: `${format(new Date(data?.updatedAt), "P")} last updated`,
			icon: <MdOutlineSecurityUpdateGood />,
		},
		{
			title: "level",
			icon: <GiLevelEndFlag />,
		},
		{
			title: "Full lifetime access",
			icon: <PiInfinityLight />,
		},
		{
			title: data.language,
			icon: <LiaLanguageSolid />,
		},
		{
			title: "certificate of completion",
			icon: <PiCertificateBold />,
		},
	];
	return (
		<div className="lesson-details__lower-part">
			<div className="lesson-details__left-part">
				<h2 className="lesson-details__header">{data.name}</h2>
				<ActivityCard data={data} />
			</div>
			<div className="lesson-details__right-part">
				<h3 className="lesson-details__course-description-header">
					course description
				</h3>
				<p className="lesson-details__course-description-text">
					{data.description}
				</p>
				<h3 className="lesson-details__course-details-header">
					course details
				</h3>
				<div className="lesson-details__course-details-list">
					{couseDetailsList.map((item) => (
						<div
							key={item.title}
							className="lesson-details__course-details-item"
						>
							{item.icon}
							<p>{item.title}</p>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default LowerPart;
